/* ============================================================================
   LAH WISHLIST — favoritos com o layout da Lahtref, salvamento pelo Growave
   Tema: Outubro (Claude 11.0)

   ============================================================================
   CORACAO NO CATALOGO
   ============================================================================
   Cada card pode ter um coracao (snippets/lah-wl-card.liquid), ao lado do
   nome ou sobre a foto, conforme Configuracoes do tema > Lahtref.

   FAVORITA A COR EXIBIDA: o botao guarda a variante inicial do card; havendo
   bolinha de cor marcada, vale a dela. Trocou de cor, o coracao acende ou
   apaga conforme aquela cor esteja na lista.

   O item entra na gaveta NA HORA com os dados do proprio card (nome, foto,
   preco do JSON de precos do card) e e completado em seguida com a foto e a
   cor certas, buscadas na loja. O preco do clique vira a base do "baixou
   desde que voce salvou", como na pagina de produto.

   MODO FOTO: o botao nasce junto ao nome e e movido para a imagem do card
   aqui. Cards que chegam depois (filtros, paginacao) sao percebidos por um
   observador e recebem o mesmo tratamento.

   ============================================================================
   A GAVETA COMO VITRINE PESSOAL
   ============================================================================
   Cada item mostra, com dados ATUAIS da loja: preco DE riscado e PARA em
   vermelho; selo "X% OFF" na cor da faixa; "Esgotado"; "Baixou R$ X desde
   que voce salvou"; botao "escolher lentes e comprar" (oculos, abre o
   configurador na chegada), "adicionar ao carrinho" (acessorios) ou "ver
   outras cores" (cor esgotada). Creditos no topo para quem tem saldo.

   O RESTO: mapa de produtos para itens sem dados; lista na conta com
   confirmacao relendo o Growave; diagnostico com ?lahteste; copia local
   instantanea; filas de adicoes e remocoes.
   ============================================================================ */

(function () {
    'use strict';

    var PENDING_KEY = 'lah_wishlist_pendente';
    var REMOVE_KEY = 'lah_wishlist_remocoes';
    var META_KEY = 'lah_wishlist_meta';
    var CACHE_PREFIX = 'lah_wishlist_cache_';
    var LOCAL_PREFIX = 'lah_wishlist_';
    var MIGRADO_PREFIX = 'lah_wishlist_migrado_';
    var GUEST_ANTIGO = 'lah_wishlist_visitante';
    var NOME_LISTA = 'Favoritos';
    var SEM_DADOS = 'Produto favoritado';
    var VALIDADE_DADOS = 10 * 60 * 1000;

    var WAKE_PRODUTO = '15398350913588';
    var WAKE_VARIANTE = '67601564434484';

    var LIMITE_SYNC = 15000;

    var TESTE = window.location.search.indexOf('lahteste') !== -1;
    try {
        if (TESTE) sessionStorage.setItem('lah_wl_teste', '1');
        else TESTE = sessionStorage.getItem('lah_wl_teste') === '1';
    } catch (e) {}

    var itens = [];
    var sdk = null;
    var growavePronto = false;
    var wishlistId = null;
    var estadoConta = 'aguardando';

    var diag = { sdk: 'não', modulo: 'não', lista: '—', itens: '—', erro: '—' };

    function logado() { return !!window.LAH_CUSTOMER_ID; }
    function idCliente() { return window.LAH_CUSTOMER_ID ? String(window.LAH_CUSTOMER_ID) : null; }

    function erroTexto(e) {
        if (!e) return 'desconhecido';
        if (typeof e === 'string') return e;
        return e.message || e.error || (e.errors && JSON.stringify(e.errors)) || JSON.stringify(e).slice(0, 140);
    }

    function registrarErro(onde, e) {
        diag.erro = onde + ': ' + erroTexto(e);
        renderDiag();
    }

    function lerJSON(chave, padrao) {
        try {
            var raw = localStorage.getItem(chave);
            return raw ? JSON.parse(raw) : padrao;
        } catch (e) { return padrao; }
    }

    function gravarJSON(chave, valor) {
        try { localStorage.setItem(chave, JSON.stringify(valor)); } catch (e) {}
    }

    function mesmo(a, b) { return String(a.variantId) === String(b.variantId); }

    function unir(listas) {
        var out = [];
        listas.forEach(function (l) {
            (l || []).forEach(function (i) {
                if (i && i.variantId && !out.some(function (o) { return mesmo(o, i); })) out.push(i);
            });
        });
        return out;
    }

    function escapeHtml(str) {
        var div = document.createElement('div');
        div.textContent = str == null ? '' : String(str);
        return div.innerHTML;
    }

    function moeda(centavos) {
        return (centavos / 100).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
    }

    /* ------------------------------------------------------------------
       Copia local e cache de exibicao
       ------------------------------------------------------------------ */
    function chaveCache(id) { return CACHE_PREFIX + (id || 'visitante'); }
    function salvarCache() { gravarJSON(chaveCache(idCliente()), itens); }
    function jaMigrado() { return logado() && lerJSON(MIGRADO_PREFIX + idCliente(), false); }

    function carregarCopiaLocal() {
        var listas = [lerJSON(chaveCache(idCliente()), []), lerJSON(PENDING_KEY, [])];

        if (logado()) {
            listas.push(lerJSON(chaveCache(null), []));
            if (!jaMigrado()) listas.push(lerJSON(LOCAL_PREFIX + idCliente(), []));
        } else {
            listas.push(lerJSON(GUEST_ANTIGO, []));
        }

        var remocoes = lerJSON(REMOVE_KEY, []);
        itens = unir(listas).filter(function (i) {
            return !remocoes.some(function (r) { return mesmo(r, i); });
        });
    }

    function metaTodas() { return lerJSON(META_KEY, {}); }

    function guardarMeta(item) {
        if (!item || item.title === SEM_DADOS) return;
        var m = metaTodas();
        m[String(item.variantId)] = {
            productId: item.productId || null,
            title: item.title, color: item.color, image: item.image,
            price: item.price, url: item.url
        };
        gravarJSON(META_KEY, m);
    }

    function handleDaUrl(url) {
        var m = (url || '').match(/\/products\/([^/?#]+)/);
        return m ? m[1] : null;
    }

    /* ------------------------------------------------------------------
       Dados atuais da loja
       ------------------------------------------------------------------ */
    var produtosCache = {};

    function buscarProduto(handle) {
        if (!produtosCache[handle]) {
            produtosCache[handle] = fetch('/products/' + handle + '.js')
                .then(function (r) { return r.ok ? r.json() : null; })
                .catch(function () { return null; });
        }
        return produtosCache[handle];
    }

    function aplicarAoVivo(item, p, variantId) {
        var v = (p.variants || []).filter(function (x) { return String(x.id) === String(variantId); })[0] || (p.variants || [])[0];
        if (!v) return item;

        item.productId = String(p.id);
        item.tipo = p.type || item.tipo || '';
        item.precoAtual = v.price;
        item.deAtual = v.compare_at_price || 0;
        item.disponivel = !!v.available;
        item.price = moeda(v.price);
        item.atualizadoEm = Date.now();
        if (item.precoSalvo == null) item.precoSalvo = v.price;
        return item;
    }

    function montarPorHandle(handle, variantId) {
        return buscarProduto(handle).then(function (p) {
            if (!p) return null;
            var v = (p.variants || []).filter(function (x) { return String(x.id) === String(variantId); })[0] || (p.variants || [])[0];
            var img = (v && v.featured_image && v.featured_image.src) || p.featured_image || '';
            if (img.indexOf('//') === 0) img = 'https:' + img;
            if (img) img += (img.indexOf('?') === -1 ? '?' : '&') + 'width=200';

            var item = {
                variantId: String(v ? v.id : variantId),
                title: p.title,
                color: v ? v.option1 : '',
                image: img,
                url: '/products/' + handle + '?variant=' + (v ? v.id : variantId)
            };
            aplicarAoVivo(item, p, item.variantId);
            guardarMeta(item);
            return item;
        });
    }

    function atualizarAoVivo() {
        var agora = Date.now();
        var vencidos = itens.filter(function (i) {
            return !semDados(i) && handleDaUrl(i.url) && (!i.atualizadoEm || agora - i.atualizadoEm > VALIDADE_DADOS);
        });
        if (!vencidos.length) return Promise.resolve();

        return Promise.all(vencidos.map(function (i) {
            return buscarProduto(handleDaUrl(i.url)).then(function (p) {
                if (p) aplicarAoVivo(i, p, i.variantId);
            });
        })).then(function () {
            salvarCache();
            renderTudo();
        });
    }

    /* ------------------------------------------------------------------
       Itens sem dados — mapa de produtos da loja
       ------------------------------------------------------------------ */
    var mapaPromessa = null;

    function mapaProdutos() {
        if (mapaPromessa) return mapaPromessa;
        mapaPromessa = fetch('/collections/all?view=lah-favoritos', { credentials: 'same-origin' })
            .then(function (r) { return r.text(); })
            .then(function (t) {
                var i = t.indexOf('{');
                var j = t.lastIndexOf('}');
                return JSON.parse(t.slice(i, j + 1));
            })
            .catch(function (e) {
                registrarErro('mapa de produtos', e);
                return { p: {}, v: {} };
            });
        return mapaPromessa;
    }

    function semDados(i) {
        return !i || i.title === SEM_DADOS || !i.title || !i.image;
    }

    function completarDesconhecidos() {
        var faltam = itens.filter(semDados);
        if (!faltam.length) return Promise.resolve();

        return mapaProdutos().then(function (mapa) {
            return Promise.all(faltam.map(function (i) {
                var pid = i.productId || (mapa.v || {})[String(i.variantId)];
                var handle = (pid && (mapa.p || {})[String(pid)]) || handleDaUrl(i.url);
                if (!handle) return null;
                return montarPorHandle(handle, i.variantId).then(function (novo) {
                    if (novo && i.precoSalvo != null) novo.precoSalvo = i.precoSalvo;
                    return novo;
                });
            }));
        }).then(function (prontos) {
            var mudou = false;
            (prontos || []).forEach(function (p) {
                if (!p) return;
                itens = itens.map(function (i) {
                    if (mesmo(i, p)) { mudou = true; return p; }
                    return i;
                });
            });
            if (mudou) {
                salvarCache();
                renderTudo();
            }
        });
    }

    /* ------------------------------------------------------------------
       Produto da pagina atual
       ------------------------------------------------------------------ */
    function produtoDaPagina() {
        var el = document.getElementById('product-lens-json-data');
        if (!el) return null;
        try { return JSON.parse(el.textContent); } catch (e) { return null; }
    }

    function currentVariantId() {
        var btn = document.querySelector('.auglio-tryon-btn-product-page');
        return btn ? btn.getAttribute('data-item_id') : null;
    }

    function variantMap() {
        var el = document.getElementById('lah-wishlist-variant-map');
        if (!el) return {};
        try { return JSON.parse(el.textContent); } catch (e) { return {}; }
    }

    function acordarGrowave() {
        if (!document.body || document.querySelector('[data-lah-wl-wake]')) return;

        var p = produtoDaPagina();
        var pid = p ? String(p.id) : WAKE_PRODUTO;
        var vid = p ? String((p.variants && p.variants[0] && p.variants[0].id) || '') : WAKE_VARIANTE;

        var caixa = document.createElement('div');
        caixa.setAttribute('data-lah-wl-wake', '');
        caixa.setAttribute('aria-hidden', 'true');
        caixa.style.cssText = 'position:absolute;left:-9999px;top:0;width:1px;height:1px;overflow:hidden;' +
            'clip:rect(0 0 0 0);clip-path:inset(50%);white-space:nowrap;pointer-events:none;';
        caixa.innerHTML = '<div class="gw-add-to-wishlist-product-card-placeholder" data-gw-product-id="' + pid +
            '" data-gw-variant-id="' + vid + '" style="display:block"></div>';
        document.body.appendChild(caixa);
    }

    function abrirLentesSePedido() {
        if (window.location.search.indexOf('lah_lentes=1') === -1) return;

        try {
            var url = new URL(window.location.href);
            url.searchParams.delete('lah_lentes');
            window.history.replaceState({}, '', url.toString());
        } catch (e) {}

        var tentativas = 0;
        (function tentar() {
            var botao = document.querySelector('.openProductLens');
            if (botao && window.Alpine) {
                setTimeout(function () { botao.click(); }, 250);
                return;
            }
            if (++tentativas > 40) return;
            setTimeout(tentar, 150);
        })();
    }

    /* ------------------------------------------------------------------
       Coracao no catalogo — ver CORACAO NO CATALOGO no topo
       ------------------------------------------------------------------ */
    function varianteDoCard(btn) {
        var card = btn.closest('product-item');
        var radio = card && card.querySelector('.color-swatch__radio:checked');
        return (radio && radio.getAttribute('data-variant-id')) || btn.getAttribute('data-variant-id');
    }

    function precosDoCard(btn, vid) {
        var card = btn.closest('product-item');
        var el = card && card.querySelector('script[data-lah-precos]');
        if (!el) return null;
        try { return (JSON.parse(el.textContent).v || {})[String(vid)] || null; } catch (e) { return null; }
    }

    function posicionarCoracoes() {
        document.querySelectorAll('[data-lah-wl-card][data-modo="foto"]').forEach(function (btn) {
            if (btn.getAttribute('data-lah-movido') === '1') return;
            var card = btn.closest('product-item');
            var foto = card && card.querySelector('.product-item__image-wrapper');
            if (!foto) return;
            foto.appendChild(btn);
            btn.setAttribute('data-lah-movido', '1');
        });
    }

    function syncCardHearts() {
        posicionarCoracoes();
        document.querySelectorAll('[data-lah-wl-card]').forEach(function (btn) {
            var fav = isFavorited(varianteDoCard(btn));
            btn.classList.toggle('is-favorited', fav);
            btn.setAttribute('aria-pressed', fav ? 'true' : 'false');
            btn.setAttribute('aria-label', fav ? 'Remover dos favoritos' : 'Adicionar aos favoritos');
        });
    }

    function toggleCardFavorite(btn) {
        var vid = varianteDoCard(btn);
        if (!vid) return;

        if (isFavorited(vid)) {
            remover(vid);
            return;
        }

        var handle = btn.getAttribute('data-handle');
        var precos = precosDoCard(btn, vid);

        var item = {
            variantId: String(vid),
            productId: btn.getAttribute('data-product-id'),
            title: btn.getAttribute('data-title'),
            color: '',
            image: btn.getAttribute('data-image'),
            price: precos ? moeda(precos[0]) : '',
            url: '/products/' + handle + '?variant=' + vid
        };

        if (precos) {
            item.precoAtual = precos[0];
            item.deAtual = precos[1] || 0;
            item.disponivel = precos[2] !== 0;
            item.precoSalvo = precos[0];
        }

        adicionar(item);

        /* Completa foto e cor da variante certa, mantendo a base de preco. */
        montarPorHandle(handle, vid).then(function (completo) {
            if (!completo) return;
            completo.precoSalvo = item.precoSalvo != null ? item.precoSalvo : completo.precoSalvo;
            itens = itens.map(function (i) { return mesmo(i, completo) ? completo : i; });
            salvarCache();
            renderTudo();
        });

        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: 'lah_wishlist_add', origem: 'catalogo', logado: logado() });
        } catch (e) {}
    }

    /* ------------------------------------------------------------------
       Growave
       ------------------------------------------------------------------ */
    function metodos() { return sdk && sdk.wishlists && sdk.wishlists.methods; }

    function resultado(r) { return r && r.result !== undefined ? r.result : r; }

    function primeiro(obj, caminhos) {
        for (var i = 0; i < caminhos.length; i++) {
            var partes = caminhos[i].split('.');
            var v = obj;
            for (var j = 0; j < partes.length && v != null; j++) v = v[partes[j]];
            if (v != null && v !== '') return String(v);
        }
        return null;
    }

    function numeroOuNada(v) {
        var n = Number(v);
        return isNaN(n) || !n ? undefined : n;
    }

    function garantirLista() {
        if (wishlistId) return Promise.resolve(wishlistId);

        return metodos().getWishlists().then(function (r) {
            var listas = resultado(r) || [];
            var achada = null;

            listas.forEach(function (l) {
                if (!achada && primeiro(l, ['title', 'name']) === NOME_LISTA) achada = l;
            });
            if (!achada) achada = listas[0];

            if (achada) {
                wishlistId = numeroOuNada(primeiro(achada, ['id', 'wishlistId']));
                diag.lista = String(wishlistId || 'sem id');
                renderDiag();
                return wishlistId;
            }

            return metodos().createWishlist(NOME_LISTA).then(function (r2) {
                var nova = resultado(r2) || {};
                wishlistId = numeroOuNada(primeiro(nova, ['id', 'wishlistId']));
                diag.lista = String(wishlistId || 'criada, sem id') + ' (nova)';
                renderDiag();
                return wishlistId;
            });
        });
    }

    function adicionarFila(item) {
        var fila = lerJSON(PENDING_KEY, []);
        if (!fila.some(function (f) { return mesmo(f, item); })) {
            fila.unshift(item);
            gravarJSON(PENDING_KEY, fila);
        }
    }

    function enviarGrowave(item) {
        return metodos().createWishlistItem(Number(item.productId), Number(item.variantId), wishlistId)
            .then(function () { return true; })
            .catch(function (e) {
                registrarErro('adicionar', e);
                adicionarFila(item);
                return false;
            });
    }

    function apagarGrowave(item) {
        var pid = item.productId || (metaTodas()[String(item.variantId)] || {}).productId;
        if (!pid) return Promise.resolve();
        return metodos().deleteWishlistItem(Number(pid), Number(item.variantId), wishlistId)
            .catch(function (e) { registrarErro('remover', e); });
    }

    function lerDoGrowave() {
        return garantirLista().then(function () {
            return metodos().getWishlistItems(wishlistId);
        }).then(function (r) {
            var lista = resultado(r) || [];
            diag.itens = String(lista.length);
            renderDiag();

            var meta = metaTodas();

            return Promise.all(lista.map(function (dto) {
                var vid = primeiro(dto, ['variantId', 'variant_id', 'product.variantId', 'variant.id']);
                var pid = primeiro(dto, ['productId', 'product_id', 'product.id']);
                var handle = primeiro(dto, ['handle', 'productHandle', 'product.handle']);
                if (!vid) return null;

                var local = itens.filter(function (i) { return String(i.variantId) === vid && !semDados(i); })[0];
                if (local) return local;

                var m = meta[vid];
                if (m && m.title && m.image) return Object.assign({ variantId: vid }, m, { productId: pid || m.productId });
                if (handle) return montarPorHandle(handle, vid);

                return { variantId: vid, productId: pid, title: SEM_DADOS, color: '', image: '', price: '', url: '#' };
            })).then(function (arr) {
                return { bruto: lista.length, itens: arr.filter(Boolean) };
            });
        });
    }

    function sincronizar() {
        var esperados = [];

        lerDoGrowave()
            .then(function (res) {
                if (res.bruto > 0 && !res.itens.length) {
                    registrarErro('ler', 'formato inesperado dos itens');
                    if (logado()) estadoConta = 'falhou';
                    return;
                }

                var base = res.itens;
                var remocoes = lerJSON(REMOVE_KEY, []);
                var cadeia = Promise.resolve();

                remocoes.forEach(function (r) {
                    if (!base.some(function (b) { return mesmo(b, r); })) return;
                    base = base.filter(function (b) { return !mesmo(b, r); });
                    cadeia = cadeia.then(function () { return apagarGrowave(r); });
                });

                var fila = unir([
                    lerJSON(PENDING_KEY, []),
                    logado() ? lerJSON(chaveCache(null), []) : [],
                    (logado() && !jaMigrado()) ? lerJSON(LOCAL_PREFIX + idCliente(), []) : [],
                    logado() ? [] : lerJSON(GUEST_ANTIGO, [])
                ]).filter(function (p) {
                    return !remocoes.some(function (r) { return mesmo(r, p); });
                });

                fila.forEach(function (p) {
                    if (base.some(function (b) { return mesmo(b, p); })) return;

                    cadeia = cadeia.then(function () {
                        var completo = p.productId
                            ? Promise.resolve(p)
                            : (handleDaUrl(p.url) ? montarPorHandle(handleDaUrl(p.url), p.variantId) : Promise.resolve(null));

                        return completo.then(function (item) {
                            if (!item || !item.productId) return;
                            if (p.precoSalvo != null) item.precoSalvo = p.precoSalvo;
                            guardarMeta(item);
                            base.unshift(item);
                            esperados.push(item);
                            return enviarGrowave(item);
                        });
                    });
                });

                return cadeia
                    .then(function () { return esperados.length ? lerDoGrowave() : { itens: base }; })
                    .then(function (conferido) {
                        var noGrowave = conferido.itens || [];
                        var faltando = esperados.filter(function (e) {
                            return !noGrowave.some(function (g) { return mesmo(g, e); });
                        });

                        itens = unir([base]);
                        gravarJSON(REMOVE_KEY, []);

                        if (faltando.length) {
                            registrarErro('conferência', faltando.length + ' item(ns) não chegaram ao Growave');
                            if (logado()) estadoConta = 'falhou';
                        } else if (logado()) {
                            gravarJSON(PENDING_KEY, []);
                            gravarJSON(chaveCache(null), []);
                            gravarJSON(GUEST_ANTIGO, []);
                            gravarJSON(MIGRADO_PREFIX + idCliente(), true);
                            estadoConta = 'ok';
                        }

                        salvarCache();
                    });
            })
            .catch(function (e) {
                registrarErro('sincronizar', e);
                if (logado()) estadoConta = 'falhou';
            })
            .then(function () {
                renderTudo();
                return completarDesconhecidos();
            })
            .then(atualizarAoVivo);
    }

    /* ------------------------------------------------------------------
       Operacoes
       ------------------------------------------------------------------ */
    function isFavorited(variantId) {
        return itens.some(function (i) { return String(i.variantId) === String(variantId); });
    }

    function adicionar(item) {
        if (isFavorited(item.variantId)) return;

        itens.unshift(item);
        guardarMeta(item);
        gravarJSON(REMOVE_KEY, lerJSON(REMOVE_KEY, []).filter(function (r) { return !mesmo(r, item); }));

        if (!logado() || !growavePronto) adicionarFila(item);
        if (growavePronto) {
            garantirLista().then(function () { return enviarGrowave(item); });
        }

        salvarCache();
        renderTudo();
    }

    function remover(variantId) {
        var item = itens.filter(function (i) { return String(i.variantId) === String(variantId); })[0];
        if (!item) return;

        itens = itens.filter(function (i) { return !mesmo(i, item); });
        gravarJSON(PENDING_KEY, lerJSON(PENDING_KEY, []).filter(function (f) { return !mesmo(f, item); }));

        if (growavePronto) {
            garantirLista().then(function () { return apagarGrowave(item); });
        } else {
            var rem = lerJSON(REMOVE_KEY, []);
            if (!rem.some(function (r) { return mesmo(r, item); })) {
                rem.push({ variantId: item.variantId, productId: item.productId || null });
                gravarJSON(REMOVE_KEY, rem);
            }
        }

        salvarCache();
        renderTudo();
    }

    function adicionarAoCarrinho(variantId, botao) {
        if (botao) { botao.disabled = true; botao.textContent = 'adicionando…'; }
        fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
        })
            .then(function (r) {
                if (!r.ok) throw new Error('add');
                window.location.href = '/cart';
            })
            .catch(function () {
                if (botao) { botao.disabled = false; botao.textContent = 'tentar de novo'; }
            });
    }

    /* ------------------------------------------------------------------
       Interface
       ------------------------------------------------------------------ */
    var estilo = document.createElement('style');
    estilo.textContent =
        '.lah-wl-diag{position:fixed;left:10px;bottom:10px;z-index:2147483600;max-width:300px;' +
        'background:rgba(17,17,17,.92);color:#fff;font:12px/1.45 Helvetica,Arial,sans-serif;' +
        'padding:10px 12px;border-radius:10px;box-shadow:0 6px 20px rgba(0,0,0,.3);}' +
        '.lah-wl-diag b{color:#9FD3B4;font-weight:600;}';
    document.head.appendChild(estilo);

    function renderDiag() {
        if (!TESTE || !document.body) return;
        var el = document.querySelector('[data-lah-wl-diag]');
        if (!el) {
            el = document.createElement('div');
            el.className = 'lah-wl-diag';
            el.setAttribute('data-lah-wl-diag', '');
            document.body.appendChild(el);
        }
        el.innerHTML =
            '<b>Diagnóstico dos favoritos</b><br>' +
            'Cliente logado: ' + (logado() ? 'sim' : 'não') + '<br>' +
            'SDK do Growave: ' + diag.sdk + '<br>' +
            'Módulo de favoritos: ' + diag.modulo + '<br>' +
            'Lista no Growave: ' + escapeHtml(diag.lista) + '<br>' +
            'Itens no Growave: ' + escapeHtml(diag.itens) + '<br>' +
            'Itens na tela: ' + itens.length + ' (sem dados: ' + itens.filter(semDados).length + ')<br>' +
            'Estado: ' + estadoConta + '<br>' +
            'Último erro: ' + escapeHtml(diag.erro);
    }

    function urlLogin() {
        var base = window.LAH_LOGIN_URL || '/account/login';
        var volta = encodeURIComponent(window.location.pathname + window.location.search);
        return base + (base.indexOf('?') > -1 ? '&' : '?') + 'return_url=' + volta;
    }

    function updateBadges() {
        var count = itens.length;
        document.querySelectorAll('.lah-wishlist-count').forEach(function (el) {
            el.textContent = count;
            el.classList.toggle('is-visible', count > 0);
        });
    }

    function corDaFaixa(pct) {
        var cfg = window.LAH_DESC_FAIXAS || {};
        var cores = cfg.cores || ['#214132', '#C2410C', '#A82B11', '#7A1F10', '#111111'];
        var f = 0;
        (cfg.lim || [30, 50, 100, 100]).forEach(function (l) {
            if (l < 100 && pct >= l) f++;
        });
        return cores[Math.min(f, cores.length - 1)];
    }

    var ICONE_CARTEIRA =
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
        '<path d="M3.5 7.5A2 2 0 0 1 5.5 5.5h11.2a1.8 1.8 0 0 1 1.8 1.8v1.2"/>' +
        '<path d="M3.5 7.5v9.2a1.8 1.8 0 0 0 1.8 1.8h13.4a1.8 1.8 0 0 0 1.8-1.8v-6.9a1.8 1.8 0 0 0-1.8-1.8H5.3"/>' +
        '<circle cx="16.7" cy="13.3" r="1.15"/></svg>';

    function topoDaGaveta() {
        if (!logado()) {
            return '<div class="lah-wl-aviso"><strong>Sua lista ainda não está salva.</strong>' +
                'Entre na sua conta para guardar seus favoritos e acessá-los em qualquer aparelho.<br>' +
                '<a href="' + urlLogin() + '" data-lah-wl-login>Entrar e salvar minha lista</a></div>';
        }

        var html = '';

        if (window.LAH_CREDITO) {
            html += '<div class="lah-wl-credito">' +
                '<span class="lah-wl-credito__icone">' + ICONE_CARTEIRA + '</span>' +
                '<span class="lah-wl-credito__texto">' +
                '<span class="lah-wl-credito__rotulo">Seus créditos</span>' +
                '<strong class="lah-wl-credito__valor">' + escapeHtml(window.LAH_CREDITO) + '</strong>' +
                '<span class="lah-wl-credito__nota">Use nesta compra, no momento do pagamento.</span>' +
                '</span></div>';
        }

        if (estadoConta === 'ok') {
            html += '<p class="lah-wl-status lah-wl-status--ok">✓ Sua lista está salva na sua conta.</p>';
        } else if (estadoConta === 'falhou') {
            html += '<p class="lah-wl-status">Não foi possível sincronizar agora. Sua lista continua guardada neste aparelho.</p>';
        } else {
            html += '<p class="lah-wl-status">Sincronizando com sua conta…</p>';
        }

        return html;
    }

    function ehOculos(item) {
        var t = (item.tipo || '').toLowerCase();
        if (!t) return true;
        return t.indexOf('culos') !== -1;
    }

    function htmlItem(item) {
        var temDados = item.precoAtual != null;
        var disponivel = item.disponivel !== false;
        var promo = temDados && item.deAtual > item.precoAtual;
        var pct = promo ? Math.round((item.deAtual - item.precoAtual) * 100 / item.deAtual) : 0;
        var queda = temDados && disponivel && item.precoSalvo != null && item.precoSalvo > item.precoAtual
            ? item.precoSalvo - item.precoAtual : 0;

        var precos = '';
        if (temDados) {
            precos = '<div class="lah-wl-precos">' +
                (promo ? '<s class="lah-wl-de">' + moeda(item.deAtual) + '</s>' : '') +
                '<span class="lah-wl-preco' + (promo ? ' lah-wl-preco--promo' : '') + '">' + moeda(item.precoAtual) + '</span>' +
                (!disponivel ? '<span class="lah-wl-selo lah-wl-selo--esgotado">Esgotado</span>' : '') +
                (disponivel && promo ? '<span class="lah-wl-selo" style="background:' + corDaFaixa(pct) + ';color:' + ((window.LAH_DESC_FAIXAS || {}).texto || '#fff') + '">' + pct + '% OFF</span>' : '') +
                '</div>';
        } else if (item.price) {
            precos = '<div class="lah-wl-precos"><span class="lah-wl-preco">' + escapeHtml(item.price) + '</span></div>';
        }

        var aviso = queda > 0
            ? '<p class="lah-wl-baixou">↓ Baixou ' + moeda(queda) + ' desde que você salvou</p>'
            : '';

        var acao;
        if (!disponivel) {
            acao = '<a class="lah-wl-cta lah-wl-cta--sec" href="' + escapeHtml(item.url) + '">ver outras cores</a>';
        } else if (ehOculos(item)) {
            var sep = item.url.indexOf('?') === -1 ? '?' : '&';
            acao = '<a class="lah-wl-cta" href="' + escapeHtml(item.url + sep + 'lah_lentes=1') + '">escolher lentes e comprar</a>';
        } else {
            acao = '<button type="button" class="lah-wl-cta" data-lah-wl-add="' + escapeHtml(item.variantId) + '">adicionar ao carrinho</button>';
        }

        return '' +
            '<div class="lah-wishlist-item">' +
                '<a class="lah-wl-foto" href="' + escapeHtml(item.url) + '">' +
                    (item.image ? '<img class="lah-wishlist-item__image" src="' + escapeHtml(item.image) + '" alt="' + escapeHtml(item.title) + '" loading="lazy">' : '') +
                '</a>' +
                '<div class="lah-wishlist-item__info">' +
                    '<a class="lah-wishlist-item__title" href="' + escapeHtml(item.url) + '">' + escapeHtml(item.title) + '</a>' +
                    (item.color ? '<span class="lah-wishlist-item__color">' + escapeHtml(item.color) + '</span>' : '') +
                    precos +
                    aviso +
                    (semDados(item) ? '' : '<div class="lah-wl-acoes">' + acao + '</div>') +
                '</div>' +
                '<button type="button" class="lah-wishlist-item__remove" data-lah-remove="' + escapeHtml(item.variantId) + '" aria-label="Remover dos favoritos">&times;</button>' +
            '</div>';
    }

    function renderDrawer() {
        var list = document.querySelector('[data-lah-wishlist-list]');
        if (!list) return;

        if (!itens.length) {
            list.innerHTML = '<div class="lah-wishlist-empty">Sua lista de favoritos está vazia.</div>';
            return;
        }

        list.innerHTML = '<div class="lah-wl-topo">' + topoDaGaveta() + '</div>' + itens.map(htmlItem).join('');
    }

    function syncProductHearts() {
        var vid = currentVariantId();
        var favorited = vid ? isFavorited(vid) : false;
        document.querySelectorAll('.lah-heart-btn').forEach(function (btn) {
            btn.classList.toggle('is-favorited', favorited);
        });
    }

    function renderTudo() {
        updateBadges();
        syncProductHearts();
        syncCardHearts();
        renderDrawer();
        renderDiag();
    }

    function openDrawer() {
        var drawer = document.getElementById('lah-wishlist-drawer');
        if (!drawer) return;
        renderDrawer();
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        document.body.classList.add('lah-wishlist-drawer-open');
        document.body.style.overflow = 'hidden';
        atualizarAoVivo();
    }

    function closeDrawer() {
        var drawer = document.getElementById('lah-wishlist-drawer');
        if (!drawer) return;
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('lah-wishlist-drawer-open');
        document.body.style.overflow = '';
    }

    function toggleProductFavorite() {
        var vid = currentVariantId();
        if (!vid) return;

        if (isFavorited(vid)) {
            remover(vid);
            return;
        }

        var data = variantMap()[vid];
        if (!data) return;

        var p = produtoDaPagina();
        var item = {
            variantId: String(vid),
            productId: p ? String(p.id) : null,
            title: data.title,
            color: data.color,
            image: data.image,
            price: data.price,
            url: data.url
        };

        if (p) {
            aplicarAoVivo(item, p, vid);
            item.precoSalvo = item.precoAtual;
        }

        adicionar(item);

        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ event: 'lah_wishlist_add', origem: 'produto', logado: logado() });
        } catch (e) {}
    }

    /* ------------------------------------------------------------------
       Eventos
       ------------------------------------------------------------------ */
    document.addEventListener('click', function (event) {
        var target = event.target;
        if (!target.closest) return;

        var cardBtn = target.closest('[data-lah-wl-card]');
        if (cardBtn) { event.preventDefault(); event.stopPropagation(); toggleCardFavorite(cardBtn); return; }

        if (target.closest('.lah-wishlist-toggle')) { event.preventDefault(); openDrawer(); return; }
        if (target.closest('[data-lah-wishlist-close]')) { event.preventDefault(); closeDrawer(); return; }

        var removeEl = target.closest('[data-lah-remove]');
        if (removeEl) { event.preventDefault(); remover(removeEl.getAttribute('data-lah-remove')); return; }

        var addEl = target.closest('[data-lah-wl-add]');
        if (addEl) { event.preventDefault(); adicionarAoCarrinho(addEl.getAttribute('data-lah-wl-add'), addEl); return; }

        if (target.closest('.lah-wl-cta')) {
            try {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ event: 'lah_wishlist_cta' });
            } catch (e) {}
            return;
        }

        if (target.closest('[data-lah-wl-login]')) {
            try {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({ event: 'lah_wishlist_login_cta', itens: itens.length });
            } catch (e) {}
            return;
        }

        if (target.closest('.lah-heart-btn')) { event.preventDefault(); toggleProductFavorite(); return; }
    }, true);

    /* Trocou a cor no card: o coracao passa a refletir a cor nova. */
    document.addEventListener('change', function (event) {
        if (event.target.classList && event.target.classList.contains('color-swatch__radio')) {
            setTimeout(syncCardHearts, 0);
        }
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeDrawer();
    });

    function watchVariantChanges() {
        var btn = document.querySelector('.auglio-tryon-btn-product-page');
        if (!btn || !window.MutationObserver) return;
        if (btn.getAttribute('data-lah-wishlist-watched') === '1') return;
        btn.setAttribute('data-lah-wishlist-watched', '1');
        new MutationObserver(syncProductHearts).observe(btn, { attributes: true, attributeFilter: ['data-item_id'] });
    }

    /* Cards que chegam depois (filtros, paginacao). */
    function observarCards() {
        var raiz = document.getElementById('main');
        if (!raiz || !window.MutationObserver) return;
        var timer = null;
        new MutationObserver(function (mutacoes) {
            var temCard = mutacoes.some(function (m) {
                return [].some.call(m.addedNodes, function (n) {
                    return n.nodeType === 1 && (n.matches('[data-lah-wl-card], product-item') || (n.querySelector && n.querySelector('[data-lah-wl-card]')));
                });
            });
            if (!temCard) return;
            clearTimeout(timer);
            timer = setTimeout(syncCardHearts, 60);
        }).observe(raiz, { childList: true, subtree: true });
    }

    /* ------------------------------------------------------------------
       Inicio
       ------------------------------------------------------------------ */
    function ativarGrowave(sdkPronto) {
        if (growavePronto) return;
        sdk = sdkPronto;
        growavePronto = true;
        diag.modulo = 'pronto';
        renderDiag();
        sincronizar();
    }

    function aoSdkPronto() {
        var s = window.gw && window.gw.sdk;
        if (!s) return;
        diag.sdk = 'carregado';
        renderDiag();
        try {
            s.runIfModuleReady(s.common.constants.modules.WISHLISTS, function () { ativarGrowave(s); });
        } catch (e) {
            registrarErro('módulo', e);
        }
    }

    carregarCopiaLocal();

    function boot() {
        renderTudo();
        watchVariantChanges();
        observarCards();
        acordarGrowave();
        abrirLentesSePedido();

        completarDesconhecidos().then(atualizarAoVivo);

        if (window.gw && window.gw.sdk) aoSdkPronto();
        document.addEventListener('gwSdkReady', aoSdkPronto);

        setTimeout(function () {
            if (growavePronto) return;
            diag.modulo = 'não ficou pronto em ' + (LIMITE_SYNC / 1000) + ' s';
            if (logado()) estadoConta = 'falhou';
            renderTudo();
        }, LIMITE_SYNC);

        var ticks = 0;
        var timer = setInterval(function () {
            ticks++;
            syncProductHearts();
            watchVariantChanges();
            if (ticks >= 15) clearInterval(timer);
        }, 1000);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', boot);
    } else {
        boot();
    }
})();
/* LAH WISHLIST — fim */
